var map = {
	"./de.json": 109,
	"./en.json": 110,
	"./fr.json": 111,
	"./ja.json": 112,
	"./ko.json": 113,
	"./pt-br.json": 114,
	"./ru.json": 115,
	"./zh.json": 116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 108;